import React from 'react';
import PropTypes from 'prop-types';
import { LineScoreDecisionsWrapper } from './LineScoreDecisions.style';
import DecisionsDataContainer from '../../Decisions/containers/DecisionsDataContainer';
import LineScoreDataContainer from '../../LineScore/containers/LineScoreDataContainer';

const LDCustomFormat = {
    useDecisionBox: false
};

const LDCustomFormatInline = {
    ...LDCustomFormat,
    simpleInline: true
};

const LineScoreDecisions = ({
  stacked = false,
  sidePadding = '0px',
  useFullName = false
}) => {
  return (
    <LineScoreDecisionsWrapper
        stacked={ stacked }
        sidePadding={ sidePadding }
    >
      <LineScoreDataContainer useFullName={useFullName}/>
      <DecisionsDataContainer customFormat={ stacked ? LDCustomFormat : LDCustomFormatInline } />
    </LineScoreDecisionsWrapper>
  )
};

LineScoreDecisions.propTypes = {
  stacked: PropTypes.bool
};

export default LineScoreDecisions;
